import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL COMPONENTS
import CountBadge from 'parts/menu/tools/CountBadge';

// STYLE
import styles from './employeeCounts.module.scss';

export default function EmployeeCounts({ changes, days }) {
  return (
    <div className={clsx('d-flex align-items-center my-1 ms-3', styles.container)}>
      <div className="me-3">
        <label className={styles.text}>Changes:</label>
        <CountBadge className="flex-grow-0" count={changes} color={changes && 'red'} />
      </div>
      {+days > 0 ? (
        <>
          <label className={styles.text}>Days:</label>
          <CountBadge className="flex-grow-0" count={days} color="red" />
        </>
      ) : null}
    </div>
  );
}
